import React from 'react';
import styles from './styles.css';
import { useInfoModal } from '../../hooks';

export default function TableFooterLegend({ legend }) {
	const infoOnClick = useInfoModal();
	return (
		<div className={styles.legendWrapper}>
			{legend.items.map((item) => (
				<div className={styles.itemWrapper} onClick={item.onclick} key={`raw-table-legend-${item.label}`}>
					<div className={`${styles[item.class]} ${styles.indicator}`} />
					<div className={`${item.checked ? '' : styles.strikeout}`}>{item.label}</div>
					{item.info ? (
						<img
							src="/dist/src/img/icons/infoSymbol.png"
							onClick={infoOnClick(item.info)}
							className={`clickable_pointer ${styles.infoIcon}`}
						/>
					) : null}
				</div>
			))}
		</div>
	);
}
